import { CustomFilterField, CustomFilterType, CustomFilterOperator } from "../Models/CustomFilterModels";

export enum ContactsFilter {
    All,
    StatusAwaitingAuthentication,
    StatusLocked,
    StatusInactive,
    NewAccountCreated,
    ContactsWithAccounts
}

export enum ContactsOrder {
    None,
    ListName,
    Email,
    ContactRef,
    Address,
    Tel1
}

export class ContactsCustomFilterFields {
    static Fields: Array<CustomFilterField> = [
        { fieldName: "FirstName", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Surname", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Company", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Town", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Postcode", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Tel", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "Email", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "ListName", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "ContactRef", fieldType: CustomFilterType.String, operators: [CustomFilterOperator.Equals, CustomFilterOperator.Contains] },
        { fieldName: "ContactType", fieldType: CustomFilterType.Collection, operators: [CustomFilterOperator.Equals] }
    ];
}

export interface ICAMSContact {
    ContactRef: string;
    ListName: string;
    ContactType: string;
    ContactTypeDescr?: string;
}

export class ContactListConfig {
    constructor() {
        this.ActionBtns = {
            account: { visible: true },
            add: { visible: true },
            edit: { visible: true },
            use: { visible: true },
            viewprint: { visible: true },
            query: { visible: true },
            export: { visible: true }
        };
    }

    ActionBtns: {
        account: { visible: boolean };
        add: { visible: boolean };
        edit: { visible: boolean };
        use: { visible: boolean };
        viewprint: { visible: boolean };
        query: { visible: boolean };
        export: { visible: boolean };
    }

    AllowMultipleSelection: Boolean = false;
    RestrictToContactsWithAccounts: Boolean = false;
}


